<template lang="pug">
v-dialog#pemegangModal(
  v-model="searchPemegang",
  width="45%",
  persistent
)
  v-form(ref="form" v-model="valid" lazy-validation)
    v-card()
      v-card-title Tambah Pemegang Izin
      v-card-text
        v-container
          v-layout(row, wrap)
            v-flex(xs4 sm4 style="margin-top:20px")
                p(class="headerSection") 
                  span  Nama
            v-flex(xs7 sm7 style="margin-top:20px")
                v-text-field(class="inputDefault" 
                    v-model='ipPemegangIzin.name' 
                    :rules='[visitorRules.required]'
                    id="fius-nama-pemegang-izin",
                    label="Nama"
                )
            v-flex(xs1 sm1)
            
            v-flex(xs4 sm4 style="margin-top:20px")
                p(class="headerSection") 
                  span  Email
            v-flex(xs7 sm7 style="margin-top:20px")
                v-text-field(class="inputDefault"
                    id="fius-email-pemegang-izin",
                    v-model='ipPemegangIzin.email' label="Email"
                    :rules='[visitorRules.required, visitorRules.email]'
                )
            v-flex(xs1 sm1)
            
            v-flex(xs4 sm4 style="margin-top:20px")
                p(class="headerSection") 
                  span  Nomor KTP
            v-flex(xs7 sm7 style="margin-top:20px")
                v-text-field(id="fius-ktp-pemegang-izin", class="inputDefault" v-model='ipPemegangIzin.ktpNumber' 
                    maxlength=16
                    :rules="[value => value.length <= 16 || 'Max 16 characters', visitorRules.ktp]"
                    label="Nomor KTP"
                )
            v-flex(xs1 sm1)

            v-flex(xs4 sm4 style="margin-top:20px")
                p(class="headerSection") 
                  span  Nomor Handphone
            v-flex(xs7 sm7 style="margin-top:20px")
                v-text-field(id="fius-nohp-pemegang-izin", class="inputDefault" v-model='ipPemegangIzin.phone' 
                    :rules='[visitorRules.required, visitorRules.phone]'
                    maxlength='15' label="Nomor Handphone"
                )
            v-flex(xs1 sm1)

            v-flex(xs4 sm4 style="margin-top:20px")
                p(class="headerSection") 
                  span  Jabatan
            v-flex(xs7 sm7 style="margin-top:20px")
                v-text-field(id="fius-jabatan-pemegang-izin", class="inputDefault" v-model='ipPemegangIzin.position' 
                    :rules='[visitorRules.required]'
                    label="Jabatan"
                )
            v-flex(xs1 sm1)

            
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="closingModal") Back
        v-btn(color="primary", @click="submit" :disabled="isModalNotComplete") Submit
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ModalIzinProyek",
  components: {},
  props: {
    searchPemegang: Boolean,
    pemegangIzin: Object,
  },
  mounted() {
    if(this.pemegangIzin) this.ipPemegangIzin = this.pemegangIzin;
  },
  data() {
    return {
      valid: true,
      fullname: "",
      idCard: "",
      department: "",
      modalHeight: "",
      totalServerItems: 0,
      ipPemegangIzin:{
        name : "",
        email:"",
        ktpNumber:"",
        phone:"",
        position: "",
      },

      // uploadBukti2: false,
      closing: false,
      docPelaporan: null,
      rules: [
        (value) =>
          (value && value.length >= 3) ||
          "Min 3 characters" ||
          !this.searchBTn.input - value,
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },
  computed: {
    ...mapState(["API_URL", "dataUsers", "searchPermitHolder", "permitHolder","visitorRules"]),
    modalHeightDynamic: {
      get() {
        return this.modalHeight;
      },
      set(val) {
        const delta = this.dynamicHeight(val);
        this.modalHeight = delta;
      },
    },
    isModalNotComplete() {
      return !this.ipPemegangIzin.name
      || !(this.ipPemegangIzin.email && (this.visitorRules.email(this.ipPemegangIzin.email) != 'Invalid e-mail.')) 
      || !(this.ipPemegangIzin.phone && (this.visitorRules.phone(this.ipPemegangIzin.phone) != 'Invalid Phone Number Format'))
      || !this.ipPemegangIzin.ktpNumber
      || !this.ipPemegangIzin.position
    }
  },
  methods: {    
    submit(){
        this.$refs.form.validate();
         if(this.$refs.form.validate() === true){
        this.$emit("selectedUser", this.ipPemegangIzin);
        this.closingModal();
         }
    },
    closingModal: function () {
      this.$emit("interface", false);
      //  this.$refs.form.validate();
      //    if(this.$refs.form.validate() === true){
      //       this.$emit("selectedUser", this.ipPemegangIzin);
      //       this.$emit("interface", false);
      //    }
    },
  },
  watch: {
  },
};
</script>

<style scoped>
.print-bg {
  background: rgb(204, 204, 204);
  padding-top: 10px;
}
.print-bg > div {
  text-align: center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin: 0 auto;
  display: inline-block;
  text-align: initial;
}
.view-width {
  width: 11.3cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding: 0 3px;
}
.padding-xy-5 {
  padding: 2px;
}
.padding-xy-1 {
  padding: 1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding: 8px 5px 0px;
  width: 35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding: 5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
  align-items: left;
}
.width-20p {
  width: 20%;
}
.width-25p {
  width: 25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align: top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top: 60px;
}
.blink {
  -webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink {
  to {
    color: #ffffff;
  }
}
@keyframes blink {
  to {
    color: #ffffff;
  }
}
@media print {
}
table {
  border-collapse: collapse;
}
.headerTable {
  border: 1px solid black;
  background-color: #cccccc;
}
.tableInput td {
  border: 1px solid black;
  padding-left: 5px;
}
.verMiddle {
  vertical-align: middle;
}
</style>